//@flow
import { type State } from "../../state";
import { type MedidaUsuarioTipo } from "../../model";

export const getMedidasUsuario = (state: State): Array<MedidaUsuarioTipo> =>
  state.medidasUsuario || [];
